import { TypographyOptions } from "@mui/material/styles/createTypography";

export const Typography = (fontFamily: string): TypographyOptions => ({
  htmlFontSize: 16,
  fontFamily,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,

  h1: {
    fontWeight: 700,
    fontSize: "2.25rem",
    lineHeight: 1.2,
    letterSpacing: "-0.025em",
  },
  h2: {
    fontWeight: 600,
    fontSize: "1.875rem",
    lineHeight: 1.25,
    letterSpacing: "-0.025em",
  },
  h3: {
    fontWeight: 600,
    fontSize: "1.5rem",
    lineHeight: 1.3,
  },
  h4: {
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: 1.4,
  },
  h5: {
    fontWeight: 500,
    fontSize: "1.125rem",
    lineHeight: 1.4,
  },
  h6: {
    fontWeight: 500,
    fontSize: "1rem",
    lineHeight: 1.5,
  },

  body1: {
    fontSize: "1rem",
    lineHeight: 1.6,
    fontWeight: 400,
  },
  body2: {
    fontSize: "0.875rem",
    lineHeight: 1.6,
    fontWeight: 400,
  },

  subtitle1: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: 1.5,
  },

  caption: {
    fontSize: "0.75rem",
    lineHeight: 1.5,
    fontWeight: 400,
  },

  overline: {
    fontSize: "0.75rem",
    fontWeight: 500,
    lineHeight: 1.5,
    textTransform: "uppercase",
    letterSpacing: "0.1em",
  },

  button: {
    textTransform: "none",
    fontWeight: 500,
    fontSize: "0.875rem",
    lineHeight: 1.5,
  },
});
